module.exports = __webpack_public_path__ + "img/Platform_Gradients-15.41e437d6.jpg";